module.exports = __webpack_public_path__ + "img/tmf2026_second.6a1a6a70.jpg";